import { HttpTypes } from '@/types';
import { AxiosInstance } from 'axios';

class AuthPartner {
  private client: AxiosInstance;
  private routePath = '/user';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async validate(email: string): Promise<HttpTypes.AdminPartnerResponse> {
    const result = await this.client.post(`${this.routePath}/partner/validate`, { email });
    return result.data;
  }

  async signin(body: HttpTypes.PartnerSignInPayload): Promise<HttpTypes.PartnerSignInUpResponse> {
    const result = await this.client.post(`${this.routePath}/partner/signin`, body);
    return result.data;
  }

  async signup(body: HttpTypes.PartnerSignUpPayload): Promise<HttpTypes.PartnerSignInUpResponse> {
    const result = await this.client.post(`${this.routePath}/partner/signup`, body);
    return result.data;
  }

  async getMe(): Promise<HttpTypes.AdminPartnerResponse> {
    const result = await this.client.get(`${this.routePath}/partner/me`);
    return result.data;
  }

  async onboard(body: HttpTypes.AdminCreatePartner): Promise<HttpTypes.AdminPartnerResponse> {
    const result = await this.client.post(`${this.routePath}/partner/onboarding`, body);
    return result.data;
  }
}

export default AuthPartner;
